<div
  class="street-address-autocomplete-field"
  [class.street-address-autocomplete-field--open]="isDropdownOpen()"
  [class.street-address-autocomplete-field--full-width]="fullWidth()"
>
  <puro-input
    [id]="fieldId"
    [label]="label()"
    [name]="inputName()"
    [formControl]="streetAddressControl"
    [required]="required()"
    [fullWidth]="fullWidth()"
    [error]="error()"
    [errorMessage]="errorMessage()"
  />

  @if (suggestionsUnavailable()) {
    <output class="street-address-autocomplete-field__unavailable">
      {{ 'createShipment.validation.addressSuggestionsUnavailable' | translate }}
    </output>
  }

  @if (isDropdownOpen()) {
    <div
      class="street-address-autocomplete-field__dropdown"
      role="listbox"
      [id]="listboxId"
      [attr.aria-label]="listboxLabel()"
    >
      @if (showNoResults()) {
        <output class="street-address-autocomplete-field__empty">
          {{ 'createShipment.fields.streetAddressNoMatches' | translate }}
        </output>
      } @else {
        @for (item of suggestions(); track item.id; let index = $index) {
          <div
            class="street-address-autocomplete-field__option"
            [id]="optionId(index)"
            role="option"
            [class.street-address-autocomplete-field__option--highlighted]="
              index === activeOptionIndex()
            "
            [attr.aria-selected]="index === activeOptionIndex()"
            (mousedown)="selectSuggestion(item, $event)"
            (mouseenter)="setActiveOption(index)"
          >
            <span class="street-address-autocomplete-field__option-text">
              @for (segment of highlightSegments(item); track $index) {
                <span
                  [class.street-address-autocomplete-field__option-match]="segment.highlighted"
                  >{{ segment.text }}</span
                >
              }</span
            ><span class="street-address-autocomplete-field__option-description"
              >, {{ item.description }}</span
            >
          </div>
        }
      }
    </div>
  }
</div>
